module.exports = __webpack_public_path__ + "img/cham_no.03141bdd.png";